import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import AVText from 'src/components/elements/AVText';
import BackSubheader from 'src/components/elements/BackSubheader';
import StickerComponent from 'src/components/elements/sendSnack/StickerComponent';
import React from 'react';
import {SendSnackDescriberData} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import {WithGlobalizeProps} from 'react-native-globalize';
import GiftBoxDetail from 'src/components/img/svg/GiftBoxDetail';
import {View} from 'react-native';
import Util, {getSenderTitle} from 'src/Util';
import AccountStore from 'src/stores/AccountStore';

export function getBackSubHeaderDescriptor(): JSX.Element {
  return <BackSubheader title="" />;
}
export function getTopHeaderSnackDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  return (
    <React.Fragment>
      <GiftBoxDetail />
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        style={getSendSnackStyleDescriptor().appTitleStyle}
        accessible
        testID="qa_SendSnackType_txt"
        nativeID="qa_SendSnackType_txt"
      >
        {props.isSender
          ? getSenderTitle(props.status)
          : Localized.Labels.formatString(
              Localized.Labels.sent_you_snack_desc,
              props.senderName,
            )}
      </AVText>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        style={getSendSnackStyleDescriptor().dateStyle}
        accessible
        testID="qa_SendSnackTime_txt"
        nativeID="qa_SendSnackTime_txt"
      >
        {props.snackDate}
      </AVText>
    </React.Fragment>
  );
}

export function getSnackStickerDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  return (
    props?.stickerId && (
      <StickerComponent id={props.stickerId} imageSize={Styles.Spacing.m7} />
    )
  );
}

export function titleDescriptor(
  props?: SendSnackDescriberData,
): string | string[] {
  return props.isSender
    ? Localized.Labels.your_snack_sent
    : Localized.Labels.formatString(
        Localized.Labels.sent_you_snack,
        props.senderName,
      );
}

export function backHeaderStyleDescriptor(): {
  [index: string]: number | string;
} {
  return null;
}
export function acceptButtonColor() {
  return Styles.Colors.Canteen.darkGreen;
}
export function renderSnackMsgDescriptor(
  props: SendSnackDescriberData & WithGlobalizeProps,
): string | string[] {
  return Localized.Labels.formatString(
    Localized.Labels.you_have_received_a_snack,
    Util.formatCurrency(props, props.amount, AccountStore.getCurrency()),
    props.senderName,
  );
}
export function snackErrorTextDescriptor() {
  return Localized.Errors.snack_error_msg_canteen;
}
export function unblockButtonType() {
  return ButtonType.normal;
}
export function snackDetailsBtnFontSTyle() {
  return {fontFamily: Styles.FontFamily.robotoRegular};
}
export function referralSummaryBtnTextFont() {
  return {};
}
export function getBlockUserBtn() {
  return null;
}
export function getUnBlockUserBtn() {
  return null;
}
export function getAcceptSnackButton({
  acceptSnack,
  snackDetails,
  context,
  isAcceptButtonVisible,
  onUnBlockUser,
  onBlockUser,
  isBlocked,
  isUserBlocked,
  isSender,
}) {
  if (isSender) {
    return null;
  }
  return isAcceptButtonVisible ? (
    <View style={getSendSnackStyleDescriptor().buttonRow}>
      <View style={getSendSnackStyleDescriptor().buttonHalf}>
        <RoundedButton
          buttonType={ButtonType.action}
          text={Localized.Buttons.block_user}
          backgroundColor={Styles.white}
          containerStyle={getSendSnackStyleDescriptor().blockUserContainer}
          color={Styles.dangerColor}
          accessibilityLabel="Block Snack User"
          textStyle={[
            getSendSnackStyleDescriptor().btnBlockUserText,
            getSendSnackStyleDescriptor().blockUserTextStyle,
          ]}
          onPress={onBlockUser}
          accessible
          testID="qa_BlockUser_btn"
          nativeID="qa_BlockUser_btn"
        />
      </View>
      <View style={getSendSnackStyleDescriptor().buttonHalf}>
        <RoundedButton
          accessibilityLabel={Localized.Buttons.accept_snack}
          buttonType={ButtonType.action}
          color={acceptButtonColor()}
          text={Localized.Buttons.accept_snack}
          containerStyle={getSendSnackStyleDescriptor().acceptBtnContainer}
          textStyle={getSendSnackStyleDescriptor().btnAccept}
          onPress={() =>
            acceptSnack?.({
              snackDetails,
              context,
            })
          }
          accessible
          testID="qa_AcceptSnack_btn"
          nativeID="qa_AcceptSnack_btn"
        />
      </View>
    </View>
  ) : (
    <View>
      {isBlocked && !isUserBlocked ? (
        <RoundedButton
          buttonType={ButtonType.action}
          text={Localized.Labels.unblock_user}
          backgroundColor={Styles.white}
          containerStyle={getSendSnackStyleDescriptor().unBlockUserContainer}
          color={Styles.dangerColor}
          accessibilityLabel="Blocked"
          textStyle={[
            getSendSnackStyleDescriptor().btnBlockUserText,
            getSendSnackStyleDescriptor().blockUserTextStyle,
          ]}
          onPress={onUnBlockUser}
          accessible
          testID="qa_UnblockUser_btn"
          nativeID="qa_UnblockUser_btn"
        />
      ) : (
        <RoundedButton
          buttonType={ButtonType.action}
          text={Localized.Buttons.block_user}
          backgroundColor={Styles.white}
          containerStyle={getSendSnackStyleDescriptor().unBlockUserContainer}
          color={Styles.dangerColor}
          accessibilityLabel="Block Snack User"
          textStyle={[
            getSendSnackStyleDescriptor().btnBlockUserText,
            getSendSnackStyleDescriptor().blockUserTextStyle,
          ]}
          onPress={onBlockUser}
          accessible
          testID="qa_BlockUser_btn"
          nativeID="qa_BlockUser_btn"
        />
      )}
    </View>
  );
}

export function getSendSnackStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    btnBlockUserText: {
      flex: 1,
    },
    topRow: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      marginBottom: Styles.Spacing.m3,
    },
    content: {
      padding: Styles.Spacing.m3,
      flex: 1,
    },
    appTitleStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.sectionHeader,
      fontWeight: 'bold',
      flex: 1,
      paddingTop: Styles.Spacing.m2,
    },
    dateStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      marginRight: Styles.Spacing.m2,
      top: 2,
    },
    description: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m1,
      fontSize: Styles.Fonts.f1,
    },
    message: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
    },
    receiverSnackStatusText: {
      color: Styles.black,
      flex: 1,
      textAlign: 'center',
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
    },
    amount: {
      color: Styles.black,
      fontSize: Styles.Fonts.f4,
      fontWeight: 'bold',
    },
    btnBlockUser: {
      marginTop: Styles.Spacing.m3,
      width: '100%',
    },
    blockUserHeaderText: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
      marginBottom: Styles.Spacing.m2,
    },
    blockUserHeaderTextDesc: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    btnAccept: {},
    buttonRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: Styles.Spacing.m3,
    },
    buttonHalf: {
      flex: 1,
    },
    blockUserContainer: {
      width: '90%',
      borderWidth: 2,
      left: Styles.Spacing.m2,
    },
    blockUserTextStyle: {
      color: Styles.dangerColor,
      textAlign: 'center',
    },
    unBlockUserContainer: {
      width: '90%',
      borderWidth: 2,
      marginLeft: 3,
    },
    acceptBtnContainer: {
      width: '90%',
      borderWidth: 2,
      left: 10,
    },
    scrollViewContent: {
      flexGrow: 1,
    },
  };
}
export function blockUnblockButtonColor() {
  return null;
}
export function snackMessageContainerStyle() {
  return {
    minHeight: 120,
  };
}
export function snackMessageContentStyle() {
  return {};
}

export default {
  getBackSubHeaderDescriptor,
  getTopHeaderSnackDescriptor,
  getSnackStickerDescriptor,
  getSendSnackStyleDescriptor,
  backHeaderStyleDescriptor,
  titleDescriptor,
  renderSnackMsgDescriptor,
  snackDetailsBtnFontSTyle,
  unblockButtonType,
  acceptButtonColor,
  snackErrorTextDescriptor,
  referralSummaryBtnTextFont,
  getUnBlockUserBtn,
  blockUnblockButtonColor,
  getAcceptSnackButton,
  getBlockUserBtn,
  snackMessageContainerStyle,
  snackMessageContentStyle,
};
